import React from 'react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

/**
 * EmptyState — État vide illustré générique (Refonte UX 07/05/2026)
 *
 * Évite les zones blanches sans contexte ("Mes documents vide", "Pas de suivi GPS").
 *
 * Props:
 *   icon: LucideIcon (illustration centrale, taille ~64px)
 *   title: string
 *   description?: string (1-2 lignes)
 *   actionLabel?: string
 *   onAction?: () => void
 *   variant?: 'default' | 'compact'
 */
const EmptyState = ({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  variant = 'default',
  className,
  testId,
}) => {
  const compact = variant === 'compact';
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        compact ? 'py-8 px-4' : 'py-16 px-6',
        className,
      )}
      data-testid={testId || 'empty-state'}
    >
      {Icon && (
        <div className={cn(
          'rounded-full bg-slate-100 flex items-center justify-center mb-4',
          compact ? 'w-12 h-12' : 'w-20 h-20',
        )}>
          <Icon className={cn('text-slate-400', compact ? 'w-6 h-6' : 'w-10 h-10')} />
        </div>
      )}
      <h3 className={cn(
        'font-semibold text-slate-900',
        compact ? 'text-sm' : 'text-base',
      )}>
        {title}
      </h3>
      {description && (
        <p className={cn(
          'text-slate-500 mt-1 max-w-md',
          compact ? 'text-xs' : 'text-sm',
        )}>
          {description}
        </p>
      )}
      {actionLabel && onAction && (
        <Button
          onClick={onAction}
          className="mt-4 bg-emerald-600 hover:bg-emerald-700"
          size={compact ? 'sm' : 'default'}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
